/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
export const useMatomo = () => {
    const matomoTracker: any | undefined = window._paq;

    const trackSearch = (keyword: string, tab: string, count: number) => {
        matomoTracker?.push([
            "trackSiteSearch",
            // Search keyword
            keyword,
            // Search category
            tab,
            // Number of results
            count,
        ]);
    };

    const track404 = () => {
        //https://matomo.org/faq/how-to/faq_60/
        matomoTracker?.push([
            "setDocumentTitle",
            `404/URL = ${encodeURIComponent(
                document.location.pathname + document.location.search
            )} /From = ${encodeURIComponent(document.referrer)}`,
        ]);
        matomoTracker?.push(["trackPageView"]);
    };

    return { trackSearch, track404 };
};
